import * as angular from 'angular';
import FlowTagsBridge from './FlowTagsBridge';

angular.module('flowingly.runner.flow').component('flowTags', FlowTagsBridge);
